module.exports = function() {
  return new Worker(__webpack_public_path__ + "09bfa8ebb314cfc46da5.worker.js");
};